import { CURRENCY, COST_FORMATTING } from '../Constants'
import numeral from 'numeral'

// We have two formattting methods here as there is an incoonsistency in how costs are stored withing the system

// This method should be used for costs pertaining to the event itself, i.e. budget.
export const formatCost = (currency: string, cost: number): string => {
  const currencySign = CURRENCY[currency]
  return `${currencySign}${numeral(cost).format(COST_FORMATTING)}`
}

// This method should be used for costs pertaining to a proposal
export const formatCents = (currency: string, cents: number): string => {
  const currencySign = CURRENCY[currency]
  return `${currencySign}${numeral(cents / 100).format(COST_FORMATTING)}`
}
